<template>
    <div class="register">
        <div class="info">
            <div class="icon">
                <svg t="1606460969808" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3722" width="36" height="36"><path d="M848.457143 128c0 0-58.514286 0-153.6-36.571429-102.4-36.571429-164.571429-76.8-164.571429-76.8L501.028571 0 475.428571 14.628571c0 0-65.828571 40.228571-164.571429 76.8-98.742857 32.914286-153.6 36.571429-153.6 36.571429L109.714286 131.657143l0 504.685714C109.714286 822.857143 457.142857 1024 501.028571 1024c40.228571 0 391.314286-201.142857 391.314286-387.657143l0-504.685714L848.457143 128zM475.428571 709.485714l-182.857143-168.228571 54.857143-69.485714 117.028571 106.057143 219.428571-274.285714 65.828571 62.171429L475.428571 709.485714 475.428571 709.485714z" p-id="3723" fill="#718eaa"></path></svg>
            </div>
            <div class="content">为了您的隐私考虑，您的<span>以下个人信息不会透露给任何第三方</span></div>
        </div>
        <main>
            <modifyInfomationForm :language-list="languageList" :field-list="fieldList" :certificate-list="certificateList" :billing-method="billingMethod"/>
        </main>
    </div>
</template>

<script>
    import modifyInfomationForm from "../components/infomation/modifyInfomationForm";
    import {getInbuilt} from "../api/ImproveInformation";
    export default {
        name: "modifyInformation",
        components:{modifyInfomationForm},
        data(){
            return{
                // TODO： 选择其他时 可自己手动填写
                // 语种 列表
                languageList: [],
                // 擅长领域  TODO: 可多选
                fieldList: [],
                // 所获证书 TODO: 可多选
                certificateList:[],
                // 收费
                billingMethod:[]
            }
        },
        methods:{
            // 获取内置数据（语种，领域， 证书）
            getInbuiltEvent(){
                getInbuilt()
                    .then(data=>{
                        this.billingMethod = data.charge_style;
                        this.certificateList = data.cert;
                        this.fieldList = data.adept_fields;
                        this.languageList = data.adept_lang;
                    })
                    .catch(error=>{
                        console.log(error)
                    })
            }
        },
        created() {
            //获取内置数据
            this.getInbuiltEvent()
        }
    }
</script>

<style scoped lang="scss">
    $distanceOfTop:120px;
    $width:800px;
    $bgColor:#0755a2;

    .register {
        min-height: calc(100vh - #{$distanceOfTop});
        padding-top: $distanceOfTop;
        margin-bottom: 20px;
        $size: 26px;

        .info {
            width: $width - 15px;
            margin: 0 auto 15px;
            padding-left: 15px;
            height: $size;
            display: flex;
            align-items: center;

            .icon svg {
                width: $size;
                height: $size;
            }

            .content {
                font-size: 15px;
                color: #718eaa;
                margin-left: 5px;
                letter-spacing: 1px;
                position: relative;

                :after {
                    content: "";
                    height: 1px;
                    background-color: #718eaa;
                    width: 100%;
                    display: inline-block;
                    position: absolute;
                    left: 0;
                    bottom: -5px;
                }
                span {
                    font-weight: bolder;
                }
            }
        }
    }
</style>